/**
 * Locais dos painéis de monitoramento nas duas numerações existentes.
 *
 * MV: código da empresa, aninhado por base porque o código se repete entre bases
 * (HSLS, HSR, HCMS e HSLB são todos 1 em bases diferentes).
 * INSIGHTCARE: ID do local, único em todo o grupo.
 */
const UNIDADES = {
	'MV': {
		'db-orcl-hsl': {
			1: {
				sigla: 'HSLS',
				nome: 'Hospital Santa Lúcia Sul',
				BoolPainelMonitoramentoPS: 1
			},
			3: {
				sigla: 'HSLG',
				nome: 'Hospital Santa Lúcia Gama',
				BoolPainelMonitoramentoPS: 1
			},
			4: {
				sigla: 'HSLN',
				nome: 'Hospital Santa Lúcia Norte',
				BoolPainelMonitoramentoPS: 1
			},
			9: {
				sigla: 'HSLT',
				nome: 'Unidade Avançada Taguatinga',
				BoolPainelMonitoramentoPS: 1
			},
			11: {
				sigla: 'HSLA',
				nome: 'Ânima Centro Hospitalar'
			},
			12: {
				sigla: 'CRB',
				nome: 'Centro Radiológico de Brasília'
			},
			14: {
				sigla: 'CRG',
				nome: 'Centro Radiológico do Gama'
			}
		},
		'db-orcl-hsr': {
			1: {
				sigla: 'HSR',
				nome: 'Hospital Santa Rosa'
			},
			10: {
				sigla: 'HO',
				nome: 'Hospital Ortopédico'
			},
			11: {
				sigla: 'UAVG',
				nome: 'Unidade Avançada Várzea Grande'
			}
		},
		'db-orcl-hcms': {
			1: {
				sigla: 'HCMS',
				nome: 'HCMS',
				BoolPainelMonitoramentoPS: 1
			}
		},
		'db-orcl-hslb': {
			1: {
				sigla: 'HSLB',
				nome: 'Hospital Santa Lúcia Bauru',
				BoolPainelMonitoramentoPS: 1
			}
		}
	},
	'INSIGHTCARE': {
		1: {
			sigla: 'HSLS',
			nome: 'Hospital Santa Lúcia Sul'
		},
		77: {
			sigla: 'HSLN',
			nome: 'Hospital Santa Lúcia Norte'
		},
		111: {
			sigla: 'HSLG',
			nome: 'Hospital Santa Lúcia Gama'
		},
		295: {
			sigla: 'HSR',
			nome: 'Hospital Santa Rosa'
		},
		365: {
			sigla: 'HSLT',
			nome: 'Unidade Avançada Taguatinga'
		},
		402: {
			sigla: 'HSLA',
			nome: 'Ânima Centro Hospitalar'
		},
		561: {
			sigla: 'HO',
			nome: 'Hospital Ortopédico'
		},
		639: {
			sigla: 'HCMS',
			nome: 'HCMS'
		},
		711: {
			sigla: 'UAVG',
			nome: 'Unidade Avançada Várzea Grande'
		},
		768: {
			sigla: 'HSLB',
			nome: 'Hospital Santa Lúcia Bauru'
		}
	}
}

class AuxRoutines {

	/**
	 * Indica se a unidade do MV (base + empresa) tem Painel de Monitoramento de PS.
	 */
	static temPainelMonitoramentoPS($base, $company) {
		return UNIDADES.MV[$base]?.[Number($company)]?.BoolPainelMonitoramentoPS === 1;
	}

	/**
	 * Lista as unidades do seletor do Painel de Monitoramento de PS, em ordem
	 * alfabética de nome.
	 *
	 * A lista é fixa e atravessa bases: cada unidade aponta para a base em que o
	 * painel dela é servido, independente da base em que o usuário está agora.
	 */
	static getLocaisPainelPS() {
		return [
			{ base: 'db-orcl-hslb', company: 1, sigla: 'HSLB', nome: 'Hospital Santa Lúcia Bauru' },
			{ base: 'db-orcl-hsl', company: 1, sigla: 'HSLS', nome: 'Hospital Santa Lúcia Sul' },
			{ base: 'db-orcl-hsl', company: 4, sigla: 'HSLN', nome: 'Hospital Santa Lúcia Norte' },
			{ base: 'db-orcl-hsl', company: 9, sigla: 'HSLT', nome: 'Unidade Avançada de Taguatinga' },
			{ base: 'db-orcl-hsl', company: 3, sigla: 'HSLG', nome: 'Hospital Santa Lúcia Gama' },
			{ base: 'db-orcl-hsl', company: 11, sigla: 'HSLA', nome: 'Ânima Centro Hospitalar' },
			{ base: 'db-orcl-hcms', company: 1, sigla: 'HCMS', nome: 'Hospital do Coração' },
			{ base: 'db-orcl-hsr', company: 1, sigla: 'HSR', nome: 'Hospital Santa Rosa' },
			{ base: 'db-orcl-hsr', company: 11, sigla: 'HSRVG', nome: 'Unidade Avançada Santa Rosa Varzea Grande' },
			{ base: 'db-orcl-hsr', company: 10, sigla: 'HO', nome: 'Hospital Ortopédico' },
		].sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'));
	}

	/**
	 * Traduz a unidade do MV (base + empresa) para o ID do local na Insightcare,
	 * usando a sigla como chave entre as duas numerações.
	 * Retorna null quando a unidade não tem local correspondente na Insightcare.
	 */
	static getIdLocalInsightcare($base, $company) {
		const sigla = UNIDADES.MV[$base]?.[Number($company)]?.sigla;
		if (!sigla) return null;

		const local = Object.entries(UNIDADES.INSIGHTCARE).find(([, unidade]) => unidade.sigla === sigla);

		return local ? Number(local[0]) : null;
	}

	/**
	 * Retorna a sigla da unidade, seguindo a mesma resolução do getLocationName.
	 * Retorna vazio quando a unidade não é reconhecida.
	 */
	static getLocationInitials($base, $company, $backendUrl = null) {
		let returnValue = '';
		const unidade = UNIDADES.MV[$base]?.[Number($company)];
		if (unidade) {
			returnValue = unidade.sigla;
		}
		if ($base === 'db-orcl-hsln') {
			returnValue = 'HSLN';
		}
		if ($base === 'db-orcl-hma') {
			returnValue = 'HSLG';
		}
		if ($base === 'db-orcl-crb') {
			returnValue = 'CRB';
		}
		if ($base === 'db-orcl-crg') {
			returnValue = 'CRG';
		}
		if ($base === 'db-orcl-igesp' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('igesp'))) {
			returnValue = 'IGESP';
		}
		if ($base === 'db-orcl-santacasasjc' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('santacasasjc'))) {
			returnValue = 'SCSJC';
		}
		if ($base === 'db-orcl-hshgo' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('hsh'))) {
			returnValue = 'HSH';
		}
		if ($base === 'db-orcl-amaralcarvalho' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('amaralcarvalho'))) {
			returnValue = 'HAC';
		}
		if ($base === 'db-orcl-aebel' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('aebel'))) {
			returnValue = 'AEBEL';
		}
		if ($base === 'db-orcl-humanamagna' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('humanamagna'))) {
			returnValue = 'HM';
		}
		return returnValue;
	}

	static getLocationName($base, $company, $backendUrl = null) {
		let returnValue = 'Grupo Santa';
		if ($base === 'db-orcl-hsl') {
			if ($company === 1) returnValue = 'Hospital Santa Lúcia Sul';
			if ($company === 4) returnValue = 'Hospital Santa Lúcia Norte';
			if ($company === 9) returnValue = 'Unidade Avançada Taguatinga';
			if ($company === 11) returnValue = 'Ânima Centro Hospitalar';
		}
		if ($base === 'db-orcl-hsln') {
			returnValue = 'Hospital Santa Lúcia Norte';
		}
		if ($base === 'db-orcl-hma') {
			returnValue = 'Hospital Santa Lúcia Gama';
		}
		if ($base === 'db-orcl-hsr') {
			if ($company === 1) returnValue = 'Hospital Santa Rosa';
			if ($company === 10) returnValue = 'Hospital Ortopédico';
			if ($company === 11) returnValue = 'Unidade Avançada Várzea Grande';
		}
		if ($base === 'db-orcl-crb') {
			returnValue = 'Centro Radiológico de Brasília';
		}
		if ($base === 'db-orcl-crg') {
			returnValue = 'Centro Radiológico do Gama';
		}
		if ($base === 'db-orcl-igesp' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('igesp'))) {
			returnValue = 'IGESP';
		}
		if ($base === 'db-orcl-santacasasjc' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('santacasasjc'))) {
			returnValue = 'SCSJC';
		}
		if ($base === 'db-orcl-hshgo' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('hsh'))) {
			returnValue = 'HSH';
		}
		if ($base === 'db-orcl-amaralcarvalho' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('amaralcarvalho'))) {
			returnValue = 'Amaral Carvalho';
		}
		if ($base === 'db-orcl-aebel' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('aebel'))) {
			returnValue = 'AEBEL';
		}
		if ($base === 'db-orcl-humanamagna' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('humanamagna'))) {
			returnValue = 'Humana Magna';
		}
		if ($base === 'db-orcl-samur' || ($backendUrl !== undefined && $backendUrl !== null && $backendUrl.includes('samur'))) {
			returnValue = 'SAMUR';
		}
		return returnValue;
	}
}
export { UNIDADES };
export default AuxRoutines;